import firebase from "firebase/app";
// 必要に応じて追加する
import "firebase/auth";
import "firebase/analytics";

if (typeof window !== "undefined" && !firebase.apps.length) {
  firebase.initializeApp(
    JSON.parse(process.env["REACT_APP_FIREBASE_CONFIG"] as string)
  );
}

export type User = firebase.User;

export default firebase;
export const auth = firebase.auth();
